import { createContext } from 'react';
import { ContextWrapper } from '../../config/constants';
import { ToastActions, ToastStateType } from './toastType';

const toastContext = createContext({} as ContextWrapper<ToastStateType, ToastActions>);
toastContext.displayName = 'ToastContext';

export default toastContext;
